<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon class="header-icon" fontIcon="event_note"></mat-icon>
        {{'planning.title' | translate}}
    </h1>

    <span class="toolbar-spacer"></span>
</mat-toolbar>

<ng-container>
    <div class="option-menu">
        <div>
            <lib-button icon="add" (click)="add()" color="primary" tooltip="{{'planning.addPlanning' | translate}}">
            </lib-button>
        </div>

        <app-search-bar (searchText)="search($event)"></app-search-bar>
    </div>

    <div class="table-container">
        <table mat-table [dataSource]="planningsData" matSort>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="task_alt"></mat-icon>
                        {{'datatable.name' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row" class="clickable" (click)="selectCurrentPlanning(row.id)">
                    {{row.name}}
                </td>
            </ng-container>

            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="view_in_ar"></mat-icon>
                        {{'viewer.model' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    {{row.model?.name}}
                </td>
            </ng-container>

            <ng-container matColumnDef="tasks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="worker-column-width">
                    <div class="header-content">
                        <mat-icon fontIcon="assignment"></mat-icon>
                        {{'datatable.tasks' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row" class="worker-column-width">
                    {{row.tasksCount}}
                </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="calendar_month"></mat-icon>
                        {{'datatable.createdDate' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    {{row.createdDate | timeFormat}}
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="edit"></mat-icon>
                        Actions
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    <lib-button icon="launch" color="none" textColor="primary" tooltip="{{'planning.open' | translate}}"
                        (click)="selectCurrentPlanning(row.id)">
                    </lib-button>

                    <lib-button icon="edit" color="none" textColor="secondary" tooltip="{{'planning.edit' | translate}}"
                        (click)="editPlanning(row, false)">
                    </lib-button>

                    <lib-button icon="content_copy" color="none" textColor="tertiary"
                        tooltip="{{'planning.duplicate' | translate}}" (click)="editPlanning(row, true)">
                    </lib-button>

                    <lib-button icon="delete" color="none" textColor="danger"
                        tooltip="{{'planning.delete' | translate}}" (click)="deletePlanning(row)">
                    </lib-button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="planningsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: planningsColumns;"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="planningsColumns.length">
                    <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                    </lib-no-data>
                </td>
            </tr>
        </table>

        <mat-paginator [length]="planningsCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]" class="paginator">
        </mat-paginator>

        <div *ngIf="loading" class="table-overlay">
            <app-spinner></app-spinner>
        </div>
    </div>
</ng-container>